"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("../metadata/component");
var QUERY_METADATA_IDENTIFIERS = [
    'ComponentRef',
    'ComponentRefs',
    'ChildRef',
    'ChildrenRef'
];
// todo: @opten/resolver? or @opten/initializer/resolver?
var Resolver = /** @class */ (function () {
    function Resolver(reflector) {
        this.reflector = reflector;
    }
    // propertyCache = new Map<StaticSymbol, { [key: string]: any[] }>();
    Resolver.prototype.resolve = function (type /*Type*/) {
        var typeMetadata = this.reflector.annotations(type);
        if (typeMetadata) {
            var metadata = findLast(typeMetadata, function (c) { return c && c.metadataName === 'Component'; });
            if (metadata) {
                var propertyMetadata = this.reflector.propMetadata(type);
                return this._mergeWithPropertyMetadata(metadata, propertyMetadata, type);
            }
        }
        return null;
    };
    Resolver.prototype._mergeWithPropertyMetadata = function (component, propertyMetadata, componentType) {
        var queries = {};
        Object.keys(propertyMetadata).forEach(function (propName) {
            var query = findLast(propertyMetadata[propName], function (a) {
                return QUERY_METADATA_IDENTIFIERS.some(function (i) { return i && i === a.metadataName; });
            });
            if (query) {
                queries[propName] = query;
            }
        });
        return this._merge(component, queries, componentType);
    };
    Resolver.prototype._merge = function (component, queries, componentType) {
        var mergedQueries = component.queries
            ? __assign({}, component.queries, queries) : queries;
        return component_1.createComponent({
            className: component.className,
            observe: component.observe,
            queries: mergedQueries
        });
    };
    Resolver.prototype._getQueriesMetadata = function (queries) {
        var _this = this;
        var res = [];
        Object.keys(queries).forEach(function (propertyName) {
            var query = queries[propertyName];
            res.push(_this._getQueryMetadata(query, propertyName));
        });
        return res;
    };
    Resolver.prototype._getQueryMetadata = function (q, propertyName) {
        return {
            descendants: q.descendants,
            first: q.first,
            propertyName: propertyName,
            read: false,
            selector: q.selector
        };
    };
    return Resolver;
}());
exports.Resolver = Resolver;
function findLast(arr, condition) {
    for (var i = arr.length - 1; i >= 0; i--) {
        if (condition(arr[i])) {
            return arr[i];
        }
    }
    return null;
}
